// Mirrors spring.servlet.multipart.max-file-size on the Pro backend.
export const MAX_FILE_BYTES = 3 * 1024 * 1024;
export const MAX_FILE_LABEL = '3 MB';

export const oversizeMessage = (file) => `${file.name} is larger than ${MAX_FILE_LABEL} and was not added.`;

export const splitBySize = (files) => ({
  ok: files.filter((f) => f.size <= MAX_FILE_BYTES),
  tooBig: files.filter((f) => f.size > MAX_FILE_BYTES)
});
